import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { FeatureFlagService } from '../../services/feature-flag.service';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-faq',
  imports: [SectionWrapperComponent, MatExpansionModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FaqComponent {
  private readonly siteConfig = inject(SiteConfigService);
  private readonly featureFlags = inject(FeatureFlagService);

  readonly section = computed(() => {
    this.featureFlags.flags();
    const data = this.siteConfig.faq();
    if (!data) {
      return null;
    }
    return { ...data, items: this.featureFlags.filterItems(data.items) };
  });
}
